/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: js
 * class: Boot
 * root Object
 * @constructor
 */
js.Boot = function() {};
$hxClasses['js.Boot'] = js.Boot;
/** @private @type {Array} */
js.Boot.__name__ = ["js","Boot"];

/**
 * __unhtml
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * private static function __unhtml(s : String)
 * @private
 * @static
 * @param {string}  s 
 * @return {string}
 */
js.Boot.__unhtml = function(s) {
	return s.split("&").join("&amp;").split("<").join("&lt;").split(">").join("&gt;");
};


/**
 * __trace
 *
 * @private
 * @static
 * @param {TAnonymous(<anonymous>)}  v 
 * @param {haxe.PosInfos}  i 
 * @return {void}
 */
js.Boot.__trace = function(v,i) {
	/** @type {string} */
	var msg = i != null ? ( i.className ? i.className : i.fileName ) + ":" + i.methodName + ": " : " ";
	/** @type {Element} */
	var d;

	msg += js.Boot.__string_rec(v,"");
	if(typeof(document) != "undefined" && (d = document.getElementById("haxe:trace")) != null) d.innerHTML += js.Boot.__unhtml(msg) + "<br/>"; else if(typeof(console) != "undefined" && console.log != null) console.log(msg);
};


/**
 * __clear_trace
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function __clear_trace()
 * @private
 * @static
 * @return {void}
 */
js.Boot.__clear_trace = function() {
	/** @type {Element} */ 
	var d = document.getElementById("haxe:trace");
	if(d != null) d.innerHTML = "";
};


/**
 * isClass
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * @private
 * @static
 * @param {null}  o 
 * @return {boolean}
 */
js.Boot.isClass = function(o) {
	return o.__name__;
};


/**
 * isEnum
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * @private
 * @static
 * @param {null}  e 
 * @return {boolean}
 */
js.Boot.isEnum = function(e) {
	return e.__ename__;
};


/**
 * getClass
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false }],TDynamic(null))
 * @private
 * @static
 * @param {null}  o 
 * @return {null}
 */
js.Boot.getClass = function(o) {
	return o.__class__;
};


/**
 * __string_rec
 *
 * $type TFun([{ name => o, t => TAnonymous(<anonymous>), opt => false },{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * private static function __string_rec(o,s:String)
 * @private
 * @static
 * @param {TAnonymous(<anonymous>)}  o 
 * @param {string}  s 
 * @return {string}
 */
js.Boot.__string_rec = function(o,s) {
	if(o == null) return "null";
	if(s.length >= 5) return "<...>";/*  too much deep recursion*/
	/** @type {string} */ 
	var t = typeof(o);
	if(t == "function" && (o.__name__ || o.__ename__)) t = "object";
	/** @type {string} */
	var str;
	/** @type {number} */
	var i;
	/** @type {number} */
	var _g;
	switch(t) {
		case "object":
			if(o instanceof Array) {
				if(o.__enum__) {
					if(o.length == 2) return o[0];
					str = o[0] + "(";
					s += "\t";
					/** @type {number} */
					var _g1 = 2;
					_g = o.length;
					while(_g1 < _g) {
						i = _g1++;
						if(i != 2) str += "," + js.Boot.__string_rec(o[i],s); else str += js.Boot.__string_rec(o[i],s);
					}
					return str + ")";
				}
				/** @type {number} */ 
				var l = o.length;
				str = "[";
				s += "\t";
				_g = 0;
				while(_g < l) {
					/** @type {number} */
					var i1 = _g++;
					str += (i1 > 0?",":"") + js.Boot.__string_rec(o[i1],s);
				}
				str += "]";
				return str;
			}
			/** @type {string} */
			var tostr;
			try {
				tostr = o.toString;
			} catch( e ) {
				return "???";
			}
			/*  strange error on IE */
			if(tostr != null && tostr != Object.toString) {
				/** @type {string} */
				var s2 = o.toString();
				if(s2 != "[object Object]") return s2;
			}
			str = "{\n";
			s += "\t";
			/** @type {boolean} */
			var hasp = o.hasOwnProperty != null;
			for (var k in o) {
				if (hasp && !o.hasOwnProperty(k)) {
					continue;
				}
				if (k == "prototype" || k == "__class__" || k == "__super__" || k == "__interfaces__" || k == "__properties__") {
					continue;
				}
				if (str.length != 2) str += ", \n";
				str += s + k + " : " + js.Boot.__string_rec(o[k], s);
			}
			s = s.substring(1);
			str += "\n" + s + "}";
			return str;
		case "function":
			return "<function>";
		case "string":
			return o;
		default:
			return String(o);
	}
};


/**
 * __interfLoop
 *
 * $type TFun([{ name => cc, t => TDynamic(null), opt => false },{ name => cl, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private static function __interfLoop(cc : Dynamic,cl : Dynamic)
 * @private
 * @static
 * @param {null}  cc 
 * @param {null}  cl 
 * @return {boolean}
 */
js.Boot.__interfLoop = function(cc,cl) {
	if(cc == null) return false;
	if(cc == cl) return true;
	/** @type {Array} */ 
	var intf = cc.__interfaces__;
	if(intf != null) {
		/** @type {number} */ 
		var _g1 = 0;
		/** @type {number} */ 
		var _g = intf.length;
		while(_g1 < _g) {
			/** @type {number} */ 
			var i = _g1++;
			/** @type {Object} */
			var i1 = intf[i];
			if(i1 == cl || js.Boot.__interfLoop(i1,cl)) return true;
		}
	}
	return js.Boot.__interfLoop(cc.__super__,cl);
};


/**
 * __instanceof
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false },{ name => cl, t => TType(#Array,[]), opt => false }],TEnum(Bool,[]))
 * private static function __instanceof(o : Dynamic,cl)
 * @private
 * @static
 * @param {null}  o 
 * @param {#Array}  cl 
 * @return {boolean}
 */
js.Boot.__instanceof = function(o,cl) {
	try {
		if(o instanceof cl) {
			if(cl == Array) return o.__enum__ == null;
			return true;
		}
		if(js.Boot.__interfLoop(o.__class__,cl)) return true;
	} catch( e ) {
		if(cl == null) return false;
	}
	switch(cl) {
		case Int:
			return Math.ceil(o%2147483648.0) === o;
		case Float:
			return typeof(o) == "number";
		case Bool:
			return o === true || o === false;
		case String:
			return typeof(o) == "string";
		case Dynamic:
			return true;
		default:
			if (o == null) return false;
			/*  do not use isClass/isEnum here */
			if (cl == Class && o.__name__ != null) {
				return true;
			}
			if (cl == Enum && o.__ename__ != null) {
				return true;
			}
			return o.__enum__ == cl;
	}
};


/**
 * __cast
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false },{ name => t, t => TDynamic(null), opt => false }],TMono(<mono>))
 * private static function __cast(o : Dynamic, t : Dynamic)
 * @private
 * @static
 * @param {null}  o 
 * @param {null}  t 
 * @return {TMono(<mono>)}
 */
js.Boot.__cast = function(o,t) {
	if(js.Boot.__instanceof(o,t)) return o; else throw "Cannot cast " + Std.string(o) + " to " + Std.string(t);
};

/** @type {js.Boot} */
js.Boot.prototype.__class__ = js.Boot;
